/*
  Adds the promise polyfill for IE 11
*/
require('es6-promise').polyfill();
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

/*
    Imports all of the modules used in the application to build the data store.
*/
import {api_apps} from './modules/ApiAppModule';
import {api_products} from './modules/ApiProductModule';
import {auth} from './modules/AuthModule';
import {projects} from './modules/projectsModule';
import {pg_settings_module} from './modules/pgsettingsKeysModule';
import {pg_settings_callback_module} from './modules/pgsettingsCallbackModule';
import {pg_settings_mpesa_module} from './modules/pgsettingsMPESAModule';
import {accounts} from './modules/BillingAccounts';
import userModule from './modules/userModule';
import webChatModule from "./modules/webChatModule";
/*
  Exports our data store.
*/
export default new Vuex.Store({
    state: {
        loading: false,
        /*
        * status = 0 -> No loading has begun
        * status = 1 -> Loading has started
        * status = 2 -> Loading completed successfully
        * status = 3 -> Loading completed unsuccessfully
        * */
    },
    mutations: {
        setLoadingStatus(context, state) {
            context.loading = state;
        }
    },
    getters: {
        getLoadingStatus(context) {
            return context.loading;
        }
    },
    modules: {
        accounts,
        api_apps,
        api_products,
        auth,
        projects,
        pg_settings_module,
        pg_settings_mpesa_module,
        pg_settings_callback_module,
        userModule,
        webChatModule
    }
});
